module.exports = __webpack_public_path__ + "img/06186733002605.8619fd3c.png";